const VIEWER_URL_MAX_LENGTH = 4096;

/**
 * Resolve a browser-viewer target while excluding executable and credentialed
 * URL schemes. HTTP remains supported for legacy public sources, but callers
 * should prefer HTTPS.
 */
export function resolveSafeViewerUrl(value: string, baseUrl?: string): string | null {
  const candidate = String(value || "").trim();
  if (!candidate || candidate.length > VIEWER_URL_MAX_LENGTH) return null;

  try {
    const url = baseUrl ? new URL(candidate, baseUrl) : new URL(candidate);
    if (url.protocol !== "https:" && url.protocol !== "http:") return null;
    if (url.username || url.password) return null;
    return url.href;
  } catch {
    return null;
  }
}
